export const zh = {
  "NAVIGATION": {
    "HOME": "首页",
    "PORTFOLIO": "投资组合",
    "PROFILE": "个人资料"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "搜索可用交易",
      "TITLE": "仅在可用交易部分搜索"
    },
    "QUICK_FILTERS": {
      "TITLE": "快速筛选",
      "CAPTION": "选择类别",
      "DEFI": "去中心化金融",
      "STAKING": "质押",
      "FARMING": "流动性挖矿",
      "LENDING": "借贷",
      "MINING": "挖矿",
      "TRADING": "交易",
      "ALL": "全部",
      "STABLECOINS": "稳定币",
      "DEPOSITS": "存款",
      "DEXES": "去中心化交易所"
    },
    "PREMIUM_DEALS": {
      "TITLE": "优质交易",
      "CAPTION": "本周最佳交易",
      "NO_DEALS": "暂无交易",
      "NO_DEALS_AVAILABLE": "暂无可用交易",
      "GET_PREMIUM": "获取高级会员",
      "APY": "年化收益率",
      "NETWORK": "网络",
      "TOKEN_TYPE": "代币类型"
    },
    "FILTERS": {
      "TITLE": "筛选",
      "FILTERS": "筛选条件",
      "SELECT_FILTERS": "选择筛选条件",
      "APPLY": "应用"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "可用交易",
      "CAPTION": "新的市场机会",
      "NO_DEALS": "未找到机会"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "订阅状态",
      "CAPTION": "您的高级会员详情",
      "ACTIVE": "已激活",
      "INACTIVE": "未激活",
      "PERIOD": "周期",
      "EXPIRES": "到期时间",
      "PROGRESS": "订阅进度",
      "NOT_STARTED": "未开始"
    },
    "REFERRAL": {
      "TITLE": "推荐计划",
      "CAPTION": "邀请好友赚取积分",
      "RANK": "等级",
      "TOTAL_REFERRALS": "总推荐人数",
      "ACTIVE_REFERRALS": "活跃推荐人数",
      "REFERRALS_BY_LEVEL": "各级推荐人数",
      "COPY": "复制",
      "POINTS_TO_NEXT_RANK": "距离下一等级还需 {{points}} 积分"
    },
    "PREMIUM": {
      "TITLE": "高级会员",
      "CAPTION": "选择套餐获取高级功能",
      "MONTHS": "个月",
      "BEST_VALUE": "最优惠",
      "PAYMENT_METHOD": "支付方式",
      "TELEGRAM_STARS": "Telegram Stars",
      "CRYPTO": "加密货币",
      "YOU_SAVE": "节省",
      "PROCESSING": "处理中...",
      "PAY_STARS": "支付 {{amount}} Stars",
      "PAY_CRYPTO": "使用加密货币支付 ${{amount}}",
      "PAYMENT_SUCCESS": {
        "TITLE": "支付成功",
        "MESSAGE": "您的订阅已成功激活！"
      },
      "PAYMENT_ERROR": {
        "TITLE": "支付错误",
        "MESSAGE": "支付处理失败。请重试。",
        "STARS_INSUFFICIENT": "Stars 余额不足。请通过 @PremiumBot 充值 Stars。"
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "支付已取消",
        "MESSAGE": "您已取消支付。准备好时请重试。"
      },
      "PAYMENT_PENDING": {
        "TITLE": "支付处理中",
        "MESSAGE": "正在处理您的支付。请稍候。"
      },
      "BUTTONS": {
        "OK": "确定",
        "CANCEL": "取消",
        "BUY_STARS": "购买 Stars"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "提前获取高 APY 的优质交易",
      "EXCLUSIVE_DEFI": "独家 DeFi 机会，APY 高达 80%",
      "NOTIFICATIONS": "实时优质交易通知",
      "GUIDES": "详细的步骤指南和策略",
      "INSIGHTS": "每周市场分析和建议"
    },
    "FOOTER": {
      "CONTACT": "如果您有任何问题，请联系我们：",
      "EMAIL_COPIED": "电子邮件地址已复制到剪贴板",
      "SUPPORT_TITLE": "客户支持",
      "SUPPORT_CAPTION": "如有任何问题，请联系我们",
      "EMAIL": "电子邮件",
      "TELEGRAM": "Telegram"
    },
    "LANGUAGE": {
      "TITLE": "语言设置",
      "CAPTION": "选择您的首选语言",
      "LANGUAGES": {
        "EN": "英语",
        "RU": "俄语",
        "UK": "乌克兰语",
        "ES": "西班牙语",
        "AR": "阿拉伯语",
        "ZH": "中文"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "投资组合策略",
    "SUBTITLE": "可用投资组合策略概览",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "资本保值",
        "DESCRIPTION": "通过稳定币获取稳定收益的低风险策略",
        "RISK_LEVEL": "低风险"
      },
      "MODERATE": {
        "NAME": "现金流",
        "DESCRIPTION": "通过稳定币和主流加密货币获取稳定收入的低风险策略",
        "RISK_LEVEL": "低风险"
      },
      "BALANCED": {
        "NAME": "均衡",
        "DESCRIPTION": "包含稳定币、主流加密货币和精选山寨币的中等风险均衡策略",
        "RISK_LEVEL": "中等风险"
      },
      "AGGRESSIVE": {
        "NAME": "增长",
        "DESCRIPTION": "专注于主流加密货币和有前景的山寨币的高风险增长策略",
        "RISK_LEVEL": "高风险"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "稳定币",
      "BLUE_CHIPS": "主流币",
      "TOP_ALTCOINS": "优质山寨币",
      "OTHER_ALTCOINS": "其他山寨币",
      "INDICES": "指数"
    },
    "DETAILS": {
      "ASSETS": "资产",
      "YIELD_STRATEGY": "收益策略",
      "APY_PROJECTION": "APY 预测"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "返回",
    "PROJECT_NOT_FOUND": "未找到项目",
    "SETUP_STEPS": "设置步骤",
    "GO_TO_PROJECT": "前往项目",
    "STATS": {
      "APY": "年化收益率"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "准备 Web3 钱包",
        "DESCRIPTION": "安装并设置支持所选网络的 Web3 钱包。例如，为以太坊网络安装 MetaMask，为 Solana 安装 Phantom，或为 Sui 网络安装 Sui Wallet。确保您的钱包配置正确且安全。"
      },
      "CONNECT_NETWORK": {
        "TITLE": "连接网络",
        "DESCRIPTION": "在钱包中添加并连接到正确的区块链网络。如果网络没有自动添加，您可能需要使用网络的 RPC URL、Chain ID 和其他网络详情手动添加。继续之前请确保您已连接到正确的网络。"
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "检查手续费余额",
        "DESCRIPTION": "确保您的钱包中有足够的原生代币支付交易手续费。以太坊网络需要 ETH，Solana 需要 SOL，Sui 需要 SUI。具体所需金额将取决于网络拥堵程度和交易复杂度。"
      },
      "PREPARE_ASSETS": {
        "TITLE": "准备资产",
        "DESCRIPTION": "将您想要投资的特定代币（如 USDC、USDT 或 DAI）转入或购入您连接的钱包。确保代币在正确的网络上 - 某些代币存在于多个网络中，但不能直接在网络间转移。"
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "糟糕！出现错误",
    "DEFAULT_MESSAGE": "发生错误。请稍后重试。",
    "RETRY_BUTTON": "重试",
    "SPECIFIC_ERRORS": {
      "DOCKER": "服务暂时不可用。请几分钟后重试。",
      "NETWORK": "网络连接问题。请检查您的互联网连接。",
      "SERVICE": "服务暂时不可用。我们的团队正在处理。",
      "DATABASE": "数据库访问问题。请稍后重试。"
    }
  }
}; 